import { BrandPlanTactic } from 'types'
import { Checkbox } from 'components/CheckboxGroup/Checkbox'
import Styles from './CrosspostTactics.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'
import { ChannelIntegrationButton } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/ChannelIntegrationButton'
import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useHover } from '@react-aria/interactions'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import { useDisconnectWithConfirmation } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/hooks/useDisconnectWithConfirmation'
import { noop } from 'lodash'

interface TacticCheckboxProps {
  applyRedesign?: boolean
  provider: ExternalIntegrationEnum
  label: string
  value: BrandPlanTactic | 'stories'
  isDisabled?: boolean
  onCancel?: () => void
}

export const TacticCheckbox = ({
  applyRedesign = false,
  provider,
  label,
  value,
  isDisabled,
  onCancel,
}: TacticCheckboxProps) => {
  const isOnboardingRedesign = useIsOnboardingRedesign() && applyRedesign
  const { isHovered, hoverProps } = useHover({})
  const integrations = useExternalIntegrations()
  const textVariant = isOnboardingRedesign ? 'primary' : 'largeList'
  const integration =
    integrations.data?.external_integrations?.find(
      (integration: ExternalIntegration) => integration.provider === provider,
    ) || null

  const disconnectWithConfirmation = useDisconnectWithConfirmation(integration ? [integration] : [], { onCancel })

  return (
    <div className={Styles.checkboxContainer} {...hoverProps}>
      <Checkbox
        value={value}
        size={20}
        color="var(--selected-fill)"
        aria-label={label}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
        onChange={(isSelected) => {
          if (!isSelected) {
            disconnectWithConfirmation(noop)
          }
        }}
      >
        <div className={Styles.checkboxLabel}>
          <PlatformIcon size={20} platform={provider} isBrand />
          <Text variant={textVariant} color="var(--dark-80)">
            {label}
          </Text>
        </div>
        {isOnboardingRedesign && (
          <div className={Styles.channelIntegrationButton}>
            <ChannelIntegrationButton
              integrations={integration ? [integration] : []}
              isHovered={isHovered}
              provider={provider}
              isDisabled={isDisabled}
            />
          </div>
        )}
      </Checkbox>
    </div>
  )
}
